import type { DataModel, ModelTable, Space } from '../dataModelsTypes';
import type { GovernancePolicy } from './types';

export function slugify(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 64) || 'policy';
}

export function newPolicyUuid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  return `pol-${Math.random().toString(36).slice(2, 10)}-${Date.now().toString(36)}`;
}

export function pathSegment(name: string): string {
  return slugify(name);
}

export function governanceOwnerId(args: {
  space: Space;
  model?: DataModel;
  table?: ModelTable;
}): string {
  return args.table?.id || args.model?.id || args.space.id;
}

export function buildPolicyPath(args: {
  space: Space;
  model?: DataModel;
  table?: ModelTable;
  policyKey: string;
}): string {
  return `${governanceOwnerId(args)}:${args.policyKey || 'untitled'}`;
}

export function policyRecordId(policy: GovernancePolicy): string {
  const owner = policy.scope.assetId || policy.scope.modelId || policy.scope.vaultId;
  const key = policy.policyKey || slugify(policy.name) || 'policy';
  return `${policy.scope.level.toLowerCase()}:${owner}:${key}`;
}
